import React, { useState, useEffect } from "react";
import { Table, Spinner, Badge, Pagination, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";
const LIMIT = 10;

const KarleOrderHistory = () => {
  const karleAdmin = JSON.parse(localStorage.getItem("karleAdmin") || "null");
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState("");
  const navigate = useNavigate();

  const getHistory = async (p, date) => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${BASE_URL}/karle/orders/my-history`, {
        params: {
          karleAdminId: karleAdmin?._id,
          page: p,
          limit: LIMIT,
          ...(date ? { date } : {}),
        },
      });
      if (res.data.success) {
        setOrders(res.data.data.orders);
        setTotalPages(res.data.data.totalPages);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!karleAdmin?._id) return;
    getHistory(page, dateFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, dateFilter]);

  if (!karleAdmin?._id) {
    return <p className="p-4">Please log in again.</p>;
  }

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const items = [];
    let lastWasEllipsis = false;
    for (let p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || (p >= page - 1 && p <= page + 1)) {
        items.push(
          <Pagination.Item
            key={p}
            active={p === page}
            onClick={() => setPage(p)}
          >
            {p}
          </Pagination.Item>,
        );
        lastWasEllipsis = false;
      } else if (!lastWasEllipsis) {
        items.push(<Pagination.Ellipsis key={`ellipsis-${p}`} disabled />);
        lastWasEllipsis = true;
      }
    }
    return (
      <Pagination className="justify-content-center mt-3">
        <Pagination.Prev
          disabled={page === 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
        />
        {items}
        <Pagination.Next
          disabled={page === totalPages}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
        />
      </Pagination>
    );
  };

  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h3 className="mb-0">Order History</h3>
        <div className="d-flex align-items-center gap-2">
          <Form.Control
            type="date"
            style={{ width: 200 }}
            value={dateFilter}
            onChange={(e) => {
              setDateFilter(e.target.value);
              setPage(1);
            }}
          />
          {dateFilter && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                setDateFilter("");
                setPage(1);
              }}
            >
              Clear
            </Button>
          )}
        </div>
      </div>

      {isLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="oranged" />
        </div>
      ) : (
        <>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Date</th>
                <th>Items</th>
                <th>Total Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, idx) => (
                <tr key={order._id}>
                  <td>{(page - 1) * LIMIT + idx + 1}</td>
                  <td>{new Date(order.orderDate).toDateString()}</td>
                  <td style={{ fontSize: "0.85rem" }}>
                    {order.items.map((it, i) => (
                      <div key={i}>
                        {it.foodName} × {it.qty} = ₹{it.lineTotal}
                      </div>
                    ))}
                  </td>
                  <td>₹{order.totalAmount}</td>
                  <td>
                    {order.isEditable ? (
                      <Badge
                        bg="success"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/karle-dashboard")}
                      >
                        Editable - Edit
                      </Badge>
                    ) : (
                      <Badge bg="secondary">Locked</Badge>
                    )}
                  </td>
                </tr>
              ))}
              {orders.length === 0 && (
                <tr>
                  <td colSpan={5}>
                    {dateFilter ? "No order found for this date" : "No orders placed yet"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {renderPagination()}
        </>
      )}
    </div>
  );
};

export default KarleOrderHistory;
